// Initialize Swiper
var swiper = new Swiper(".mySwiper", {
	pagination: { el: ".swiper-pagination" },
	navigation: {
		nextEl: ".swiper-button-next",
		prevEl: ".swiper-button-prev",
	},
});


window.addEventListener('load', () => {

	let bodiceHandle = '';
	let skirtHandle = '';
	let combinedHandle = '';
	let lastSelectedCategory = null;

	document.querySelector('#shopify-section-footer').style.display = "none";
	
	initializeSessionStorage();

	let lookSessionCounter = parseInt(sessionStorage.getItem('lookSessionCounter')) || 1;

	let tabSelections = {};

	const lookBuilderTabs = document.querySelectorAll('.look-builder-tab');
	lookBuilderTabs.forEach(tab => {
		const tabName = tab.dataset.name;
		tabSelections[tabName] = [];
	});

	function initializeSessionStorage() {
		if (sessionStorage.getItem('customerLooks') === null) {
			sessionStorage.setItem('customerLooks', JSON.stringify([]));
		}
	}

	function sanitize(str) {
		// Implement or use a library function to sanitize strings
		return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
	}

	let currentTabIndex = getCurrentTabIndex();

	const tabList = document.querySelector('.look-builder-tabs');
	const underline = tabList.querySelector('.nav-underline');

	initTabClickListeners();
	initProductClickListeners();
	initNavigationButtons();
	initMenuHandlers();
	initCollectionClickListeners();
	
	updateButtonVisibility();

	function getCurrentTabIndex() {
		return Array.from(lookBuilderTabs).findIndex(tab => tab.classList.contains('active'));
	}

	function initTabClickListeners() {
    lookBuilderTabs.forEach((tab, index) => {
        tab.addEventListener('click', () => {
            updateTabAndButtons(index);
            scrollToTab(tab); // Call scrollToTab function when a tab is clicked
        });
    });
	}

	function scrollToTab(tab) {
    const tabsContainer = document.querySelector('.look-builder-tabs'); // This is the container that needs to scroll

    // Get the left position of the tab relative to the scrollable container
    const tabLeft = tab.offsetLeft;

    // Adjust scroll position to bring the tab to the center of the container view if possible
    const scrollPosition = tabLeft + (tab.offsetWidth / 2) - (tabsContainer.offsetWidth / 2);

    // Use smooth scrolling to scroll to the tab
    tabsContainer.scrollTo({ left: scrollPosition, behavior: 'smooth' });
	}

	function initProductClickListeners() {
		document.querySelectorAll('.look-product').forEach(product => {
			product.addEventListener('click', (e) => handleProductClick(e.currentTarget));
		});
	}

	function initCollectionClickListeners() {
		document.querySelectorAll('.look-builder-collection-tab').forEach(collection => {
			collection.addEventListener('click', (e) => handleCollectionClick(e.currentTarget));
		})
	}

	function resetSession() {
		sessionStorage.setItem('customerLooks', JSON.stringify([]));
	}

	const updateUnderlinePosition = () => {
		const activeTab = tabList.querySelector('.look-builder-tab.active');
		if (activeTab) {
			underline.style.left = activeTab.offsetLeft + 'px';
			underline.style.width = activeTab.offsetWidth + 'px';
		}
	};

	updateUnderlinePosition();

	function handleProductClick(selectedProduct) {
		const tabName = lookBuilderTabs[currentTabIndex].dataset.name;
		const currentTabProducts = document.querySelectorAll(`.look-builder-products[data-name="${tabName}"] .look-product`);

		const handle = selectedProduct.dataset.handle;

    // Determine the category of the selected product
    if (tabName.toLowerCase().includes('bodice')) {
			if (lastSelectedCategory === 'bottom') {
					// If a skirt was selected after a bodice, we might need to reset
					combinedHandle = ''; // Consider whether you need to reset this based on your app's logic
			}
			bodiceHandle = handle;
			lastSelectedCategory = 'bodice';
		} else if (tabName.toLowerCase().includes('bottom')) {
				if (bodiceHandle) {
					skirtHandle = handle;
					lastSelectedCategory = 'bottom';
					combinedHandle = bodiceHandle + '+' + skirtHandle; // Set combinedHandle only when a bodice has been previously selected
				}
		} else {
				// Reset combinedHandle if the selection is outside of the Bodice-Skirt sequence
				combinedHandle = '';
				lastSelectedCategory = null; // Reset or set to the current category as needed
		}

		// Remove 'active' class from all products in the current tab
		currentTabProducts.forEach(product => {
			product.classList.remove('active');
			updateTabSelection(tabName, product, false);  // Update selection to reflect the deactivation
		});

		// Set the clicked product as active
		selectedProduct.classList.add('active');
		updateTabSelection(tabName, selectedProduct, true);  // Update selection for the activated product

		if (selectedProduct.dataset.handle) {
			fetchAndUpdateProductImages(selectedProduct);
		}
	}

	function handleCollectionClick(selectedCollection) {
		document.querySelectorAll('.look-builder-collection-tab').forEach(collectionTab =>{
			collectionTab.classList.remove('active');
		});
		selectedCollection.classList.add('active');
		const currentTabProductsList = selectedCollection.closest('.look-builder-products.active');
		const currentCollectionHandle = selectedCollection.dataset.collectionHandle;
		currentTabProductsList.querySelectorAll('.look-collection-products, .no-collection-container').forEach(collectionContainer => {
			if (collectionContainer.dataset.collectionHandle === currentCollectionHandle) {
				collectionContainer.classList.add('active')
			} else {
				collectionContainer.classList.remove('active');
			}
		})
	}

	function initCollectionSelectListener() {
		// Select the dropdown element
		document.querySelectorAll('.look-builder-collection-tabs-dropdown').forEach(dropdown => {
			dropdown.addEventListener('change', (e) => handleCollectionSelect(e.currentTarget));
		})
	}
	
	function handleCollectionSelect(selectedDropdown) {
		// Get the selected option's data-collection-handle attribute
		const selectedOption = selectedDropdown.options[selectedDropdown.selectedIndex];
		const currentCollectionHandle = selectedOption.dataset.collectionHandle;
	
		// Find the look-builder-products element that is currently active
		const currentTabProductsList = selectedDropdown.closest('.look-builder-products.active');
	
		// Toggle the active class on the correct collection container based on the selected collection handle
		currentTabProductsList.querySelectorAll('.look-collection-products, .no-collection-container').forEach(collectionContainer => {
			if (collectionContainer.dataset.collectionHandle === currentCollectionHandle) {
				collectionContainer.classList.add('active');
			} else {
				collectionContainer.classList.remove('active');
			}
		});
	}
	
	// Call this function when the page loads or when the relevant content is dynamically added to the page
	initCollectionSelectListener();
	

	function updateTabSelection(tabName, product, isSelected) {
		const productDetails = {
			handle: product.dataset.handle,
			title: product.querySelector('.look-product-information h3')?.textContent,
			description: product.querySelector('.look-product-information p')?.textContent,
			imageSrc: product.querySelector('.look-product-image img')?.src
		};

		if (isSelected) {
			// Check if the product is already in the array to avoid duplicates
			if (!tabSelections[tabName].some(p => p.handle === productDetails.handle)) {
				tabSelections[tabName].push(productDetails);
			}
		} else {
			// Remove the product if it's deselected
			tabSelections[tabName] = tabSelections[tabName].filter(p => p.handle !== productDetails.handle);
		}
	}

	function fetchAndUpdateProductImages(selectedProduct) {
    const rootUrl = getRootUrl(selectedProduct.dataset.rootUrl);
    const loader = document.querySelector('.loader');
    loader.style.display = "block";

    let fetchUrl = `${rootUrl}products/${selectedProduct.dataset.handle}?view=look_builder`;
    if (combinedHandle) {
        // If combinedHandle is set, modify the fetchUrl to use it
        fetchUrl = `${rootUrl}products/${selectedProduct.dataset.handle}/${combinedHandle}?view=look_builder`;
    }

    fetch(fetchUrl)
        .then(response => response.text())
        .then(text => updateProductImages(text))
        .finally(() => loader.style.display = "none")
        .catch(error => console.error(`Error loading product images`, error));
	}

	function shouldUseCombinedImages(selectedProduct) {
    const tabName = lookBuilderTabs[currentTabIndex].dataset.name;
    return tabName.toLowerCase().includes('combined'); // Placeholder condition
	}

	function getRootUrl(url) {
		return url.endsWith("/") ? url : url + "/";
	}

	function updateProductImages(text) {
		const html = new DOMParser().parseFromString(text, 'text/html');
		const productImagesDestination = html.querySelector('.look-builder-images');
		const productImagesSource = document.querySelector('.look-builder-images');
		if (productImagesDestination && productImagesSource) {
			productImagesSource.innerHTML = productImagesDestination.innerHTML;
			initializeNewSwiper();
		}
	}

	function initializeNewSwiper() {
		new Swiper(".mySwiper", {
			pagination: { el: ".swiper-pagination" },
			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev",
			},
		});
	}

	function updateTabAndButtons(newIndex) {
    lookBuilderTabs.forEach((tab, index) => {
        const isActive = index === newIndex;
        tab.classList.toggle('active', isActive);
        const productSection = document.querySelector(`.look-builder-products[data-name="${tab.dataset.name}"]`);
        productSection.classList.toggle('active', isActive);
    });
    currentTabIndex = newIndex;
    updateButtonVisibility();
    updateUnderlinePosition();

    // Scroll to the active tab
    const activeTab = lookBuilderTabs[newIndex];
    if (activeTab) scrollToTab(activeTab); // Ensure scrollToTab is called with the currently active tab
	}

	function initNavigationButtons() {
		const nextButton = document.querySelector('.next-button-navigation');
		const prevButton = document.querySelector('.previous-button-navigation');
		nextButton.addEventListener('click', () => {
			if (currentTabIndex < lookBuilderTabs.length - 1) {
				updateTabAndButtons(currentTabIndex + 1);
			}
		});
		prevButton.addEventListener('click', () => {
			if (currentTabIndex > 0) {
				updateTabAndButtons(currentTabIndex - 1);
			}
		});
	}

	function updateButtonVisibility() {
		const nextButton = document.querySelector('.next-button-navigation');
		const prevButton = document.querySelector('.previous-button-navigation');
		const addToFormButton = document.querySelector('.submit-button-navigation');
		const skipButton = document.querySelector('.skip-button-navigation'); // Get the skip button

		prevButton.style.display = currentTabIndex === 0 ? 'none' : 'block';
		nextButton.style.display = currentTabIndex === lookBuilderTabs.length - 1 ? 'none' : 'block';
		addToFormButton.parentElement.classList.toggle('none-important', currentTabIndex !== lookBuilderTabs.length - 1);

		// Hide the skip button if it's the last tab, otherwise show it
		if (skipButton) {
			skipButton.style.display = currentTabIndex === lookBuilderTabs.length - 1 ? 'none' : 'block';
		}
	}

	function initSkipButton() {
		const skipButton = document.querySelector('.skip-button-navigation');
		if (skipButton) {
			skipButton.addEventListener('click', handleSkip);
		}
	}

	initSkipButton();

	function handleSkip() {
		const tabName = lookBuilderTabs[currentTabIndex].dataset.name;
		const currentTabProducts = document.querySelectorAll(`.look-builder-products[data-name="${tabName}"] .look-product`);

		currentTabProducts.forEach(product => {
			product.classList.remove('active');  // Remove active class
			updateTabSelection(tabName, product, false);  // Update tab selections
		});

		// Advance to the next tab if it's not the last tab
		if (currentTabIndex < lookBuilderTabs.length - 1) {
			updateTabAndButtons(currentTabIndex + 1);
		}
	}

	function initMenuHandlers() {
		// Handle opening of the menu by the submit-button-navigation button
		document.querySelectorAll('.submit-button-navigation').forEach(button => {
			button.addEventListener('click', function () {
				const menuId = button.getAttribute('data-menu');
				const menu = document.querySelector(menuId);

				if (menu) {
					menu.classList.toggle('js-menu__expanded');
					if (menu.parentElement) {
						menu.parentElement.classList.toggle('js-menu__expanded');
					}
					saveCurrentLook();
					populateMenuWithLooks();
				}
			});
		});

		// Handle opening of the menu by js-menu__open class elements
		document.querySelectorAll('.js-menu__open').forEach(menuIcon => {
			menuIcon.addEventListener('click', function () {
				const menuId = menuIcon.getAttribute('data-menu');
				const menu = document.querySelector(menuId);

				if (menu) {
					menu.classList.toggle('js-menu__expanded');
					if (menu.parentElement) {
						menu.parentElement.classList.toggle('js-menu__expanded');
					}
					document.querySelector('body').style.overflow = "hidden";
				}
			});
		});

		// Handle closing of the menu
		document.querySelectorAll('.js-menu__context, .js-menu__close').forEach(element => {
			element.addEventListener('click', function (event) {
				if (event.target.classList.contains('js-menu__context') || event.target.classList.contains('js-menu__close')) {
					document.querySelectorAll('.js-menu__expanded').forEach(expandedMenu => {
						expandedMenu.classList.remove('js-menu__expanded');
					});
					document.querySelector('body').style.overflow = "auto";
				}
			});
		});
	}

	const currentProductHandle = getProductHandleFromUrl();
	if (currentProductHandle) {
		activateProductAndTab(currentProductHandle);
	}

	function getProductHandleFromUrl() {
		const path = window.location.pathname;
		const pathParts = path.split('/');
		return pathParts.length > 2 ? pathParts[2] : null;
	}

	function activateProductAndTab(handle) {
		const products = document.querySelectorAll('.look-product');
		let firstProductFound = false; // Flag to track if the first product is found

		products.forEach(product => {
			if (!firstProductFound && product.dataset.handle === handle) {
				product.classList.add('active');
				fetchAndUpdateProductImages(product);
				const tabName = product.closest('.look-builder-products').dataset.name;
				activateTab(tabName);
				scrollToProduct(product);
				firstProductFound = true; // Set the flag to true after activating the first product

				// Update the tabSelections for the activated product
				updateTabSelection(tabName, product, true);
			}
		});
	}

	document.querySelector('.build-another-look-link').addEventListener('click', () => {
		// Close the pop-up
		document.querySelectorAll('.js-menu__expanded').forEach(menu => menu.classList.remove('js-menu__expanded'));
		document.querySelector('body').style.overflow = "auto";

		// Reset tabs and products
		resetTabsAndProducts();

		// Navigate to the first tab
		updateTabAndButtons(0);

		// Select the first product of the first tab
		selectFirstProductOfFirstTab();

		// Scroll to the first active product after a short delay
		setTimeout(() => {
			scrollToSelectedTab();
			scrollToFirstProductOfFirstTab();
		}, 100);
	});

	function scrollToProduct(product) {
		const lookBuilderStatic = document.querySelector('.look-builder-static');
		const productTop = product.offsetTop - 50;
		lookBuilderStatic.scrollTop = productTop - lookBuilderStatic.offsetTop;
	}

	function activateTab(name) {
		const tabs = document.querySelectorAll('.look-builder-tab');
		tabs.forEach((tab, index) => {
			if (tab.dataset.name === name) {
				tab.classList.add('active');
				updateTabAndButtons(index); // Assuming you have this function from previous implementation
			} else {
				tab.classList.remove('active');
			}
		});
	}

	function saveCurrentLook() {
		// Clear custom builder session storage if it exists
		if (sessionStorage.getItem('customerCustomLooks')) {
			sessionStorage.removeItem('customerCustomLooks');
		}

		// Existing logic to save the current look for the bespoke builder
		const existingLooks = JSON.parse(sessionStorage.getItem('customerLooks')) || [];
		const currentLook = {
			sessionNumber: lookSessionCounter,
			products: Object.values(tabSelections).flat()
		};
		existingLooks.push(currentLook);
		sessionStorage.setItem('customerLooks', JSON.stringify(existingLooks));
		lookSessionCounter++;
		sessionStorage.setItem('lookSessionCounter', lookSessionCounter.toString());

		// Set a flag in sessionStorage and show the dress icon
		sessionStorage.setItem('summaryDisplayed', 'true');
		document.querySelector('.dress--cart-dot').removeAttribute('hidden');
	}


	function populateMenuWithLooks() {
		const menu = document.querySelector('.look-products-content');
		const looks = JSON.parse(sessionStorage.getItem('customerLooks'));
		menu.innerHTML = '';
		looks.forEach((look, lookIndex) => {
			const lookDiv = document.createElement('div');
			lookDiv.className = 'look';
			lookDiv.innerHTML = `<h2>${lookIndex + 1}.</h2>`;
			look.products.forEach(product => {
				lookDiv.innerHTML += `
							<div class="menu-product">
								<div class="look-drawer-content">
									<div class="look-drawer-image">
										<img src="${product.imageSrc}" alt="${product.title}">
									</div>
									<div class="look-drawer-info">
										<h3>${product.title}</h3>
									</div>
								</div>
							</div>
            `;
			});
			menu.appendChild(lookDiv);
		});
	}

	function resetTabsAndProducts() {
		document.querySelectorAll('.look-builder-tab').forEach(tab => tab.classList.remove('active'));
		document.querySelectorAll('.look-product').forEach(product => product.classList.remove('active'));
		// Reset your tabSelections object
		tabSelections = resetTabSelections();
	}

	function selectFirstProductOfFirstTab() {
		const firstTab = document.querySelector('.look-builder-tab');
		const firstProduct = document.querySelector('.look-builder-products[data-name="' + firstTab.dataset.name + '"] .look-product');
		if (firstProduct) {
			firstProduct.click();
		}
	}

	function resetTabSelections() {
		let newSelections = {};
		document.querySelectorAll('.look-builder-tab').forEach(tab => {
			const tabName = tab.dataset.name;
			newSelections[tabName] = [];
		});
		return newSelections;
	}

	function scrollToSelectedTab() {
		const tabsContainer = document.querySelector('.look-builder-tabs'); // Adjust the selector as needed
		const selectedTab = document.querySelector('.look-builder-tab.active'); // Assuming 'active' class marks the selected tab
		const scrollableElement = document.querySelector('.look-builder-static'); // The element with overflow-y scroll
	
		if (selectedTab) {
			// Scroll the tabs container to show the selected tab
			tabsContainer.scrollLeft = selectedTab.offsetLeft - tabsContainer.offsetLeft;
		}
	
		// Scroll the scrollable element to its top
		if (scrollableElement) {
			scrollableElement.scrollTop = 0;
		}
	
		// Scroll the whole window to the top
		window.scrollTo({ top: 0, behavior: 'smooth' });
	}

	function scrollToFirstProductOfFirstTab() {
		const lookBuilderStatic = document.querySelector('.look-builder-static');
		const firstProduct = document.querySelector('.look-builder-products .look-product');

		if (firstProduct) {
			const offset = 0;
			const productTop = firstProduct.offsetTop - lookBuilderStatic.offsetTop - offset;
			lookBuilderStatic.scrollTop = productTop;
		}
	}
});